import modal from '../../components/modal.js';
import buttonLoader from '../../utilities/buttonLoader.js';

var timetableRegister = {};

timetableRegister = {
  Register: {

    init: function () {
      var me = this;

      var classButtons = document.getElementsByClassName('action-register-class');

      Array.prototype.forEach.call(classButtons, function (button, index) {

        if (button) {
          me.bindClasses(button);
        }

      });

    },

    bindClasses: function (button) {

      button.addEventListener('click', function (e) {

        e.preventDefault();
        e.stopPropagation();

        var type = e.target.getAttribute('data-type');

        var id = 'class__register'

        var form = document.getElementsByClassName('classRegisterForm')[0];

        form.querySelector('input[name=itemId]').value = button.getAttribute('data-itemId');

        modal.toggle(id);

      });

    }
  },

  WaitingList: {
    init: function () {
      var me = this;

      var classButtons = document.getElementsByClassName('action-waitinglist-class');

      Array.prototype.forEach.call(classButtons, function (button, index) {

        if (button) {
          me.bindClasses(button);
        }

      });

    },

    bindClasses: function (button) {

      button.addEventListener('click', function (e) {

        e.preventDefault();
        e.stopPropagation();

        var type = e.target.getAttribute('data-type');

        var id = 'waiting__register'

        var form = document.getElementsByClassName('classWaitingRegisterForm')[0];

        form.querySelector('input[name=itemId]').value = button.getAttribute('data-itemId');

        modal.toggle(id);

      });

    }
  },

  Unsubscribe: {

    init: function () {

      var me = this;

      var classButtons = document.getElementsByClassName('action-unsubscribe-class');

      Array.prototype.forEach.call(classButtons, function (button, index) {

        me.bindClasses(button);

      });

    },

    bindClasses: function (button) {
      var me = this;

      button.addEventListener('click', function (e) {

        e.preventDefault();
      
        me.submit(button);

      });

    },

    submit: function (button) {

      var itemId = button.getAttribute('data-itemId');


      buttonLoader.start(button);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/umbraco/surface/classes/unsubscribe?itemId=' + itemId);

      xhr.onload = function () {

        var resp = JSON.parse(xhr.response);

        if (xhr.status >= 200 && xhr.status < 300) {

          if (resp.success) {
            if (button.classList.contains('js-mypage')) {
              var rowsCount = document.querySelectorAll('.js-mypage-class');
              var row = button.parentElement.parentElement.parentElement;
              row.remove();
              if (rowsCount.length === 0 || rowsCount === "" || rowsCount === null) {
                var classOverview = document.querySelector('.classOverview');
                classOverview.querySelector("a").remove();
                classOverview.querySelector(".tableFlex").remove();
                var sleeping = document.createElement('div');
                var linkMore = document.createElement('a');
                linkMore.className = "button button--expanded button--hollow button--small";
                linkMore.innerText = classOverview.getAttribute('data-available-classes');
                sleeping.className = 'attendance__sleeping';
                sleeping.innerHTML = `
                    <svg viewBox="0 0 100 100">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/content/hreyfing/icons/svg/symbols.svg#SleepBoldMan"></use>
                    </svg>
                    <span>${classOverview.getAttribute('data-no-classes')}</span>`;
                  classOverview.appendChild(sleeping)
                  classOverview.appendChild(linkMore)
                
              }
            }
            buttonLoader.reset(button);

            button.querySelector('span').innerText = button.getAttribute('data-default');

            // unsubscribing from waiting list
            if (button.classList.contains('action-unsubscribe-waitinglist-class')) {
              button.classList.remove('button--burgundy','action-unsubscribe-waitinglist-class', 'action-unsubscribe-class');
              button.classList.add('button--primary','action-waitinglist-class');

              var buttonClone = button.cloneNode(true);
              button.parentNode.replaceChild(buttonClone, button);
              timetableRegister.WaitingList.bindClasses(buttonClone);
            }
            // unsubscribing from class
            else {
              button.classList.remove('button--burgundy','action-unsubscribe-class');
              button.classList.add('button--primary','action-register-class');

              var buttonClone = button.cloneNode(true);
              button.parentNode.replaceChild(buttonClone, button);
              timetableRegister.Register.bindClasses(buttonClone);
            }

          } else {

            buttonLoader.reset(button);

            alert(resp.message);
          }

        } else {

          buttonLoader.reset(button);

          alert('server error');
        }

      };

      xhr.send();

    }
  }
}



timetableRegister.initialize = function () {
  timetableRegister.Register.init();
  timetableRegister.WaitingList.init();
  timetableRegister.Unsubscribe.init();
};

module.exports = timetableRegister;
